import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment.prod';

declare var gtag: (command: string, eventNameOrMeasurementId: string, eventParamsOrConfig?: any) => void;

@Injectable()
export class GtagService {
  private MEASUREMENT_ID = environment.measurementId;

  sendEvent(eventName: string, eventParams: any): void {
    gtag('event', eventName, eventParams);
  }

  setConfig(url: string): void {
    gtag('config', this.MEASUREMENT_ID, { page_path: url });
  }

  setPageView(): void {
    this.sendEvent('page_view', { send_to: this.MEASUREMENT_ID });
  }
}
